
/* jshint esversion: 9 */

import * as sdk from "matrix-js-sdk";
import {RoomEvent} from "matrix-js-sdk/lib/models/room";
import {KnownMembership} from "matrix-js-sdk/lib/@types/membership";
import {Visibility} from "matrix-js-sdk/lib/@types/partials";
import {ClientEvent} from "matrix-js-sdk/lib/client";
import {decodeRecoveryKey, encodeRecoveryKey} from "matrix-js-sdk/lib/crypto-api/recovery-key";
import {RoomMemberEvent} from "matrix-js-sdk/lib/models/room-member";
import {DateProgressElement, ZiegeProgressElement} from "./progress.js";
import {CryptoEvent} from "matrix-js-sdk/lib/crypto-api";

import  {Elm} from "./ziegeelm"


const ZIEGE_STATUS_UPDATE_MESSAGE_TYPE = "app.ziege.clientupdate"
const ZIEGE_ROOM_TAG = "ziege-goes-maa"
const MEGOLM_ENCRYPTION_ALGORITHM = "m.megolm.v1.aes-sha2"
const ZIEGE_MARKER_STATE_EVENT_TYPE = "app.ziege.this_is_a_ziege_room"
const ZIEGE_BASE_URL = "https://matrix.ziege.social";

function calculate_sso_redirect_uri(hash="auth") {
    if (window.hasOwnProperty("cordova")) {
        return "ziege://#" + hash
    }

    let url = new URL(window.location.href);
    url.hash = hash
    return url.href
}

function playPling() {
    /*
    let audioElement = new Audio("static/baeh.wav")
    audioElement.addEventListener("canplaythrough", event => {
        // the audio is now playable; play it if permissions allow
        audioElement.play();
    });
    */
}

function initPush() {

}



function getDeviceId() {
    if (window.hasOwnProperty("cordova")) {
        try {
            return device.uuid; // cordova device plugin
        } catch (e) {
            console.error("no device plugin in cordova?")
            return crypto.randomUUID();
        }
    } else {
        let deviceId = localStorage.getItem("ziege_device_id");
        if (!deviceId) {
            deviceId = crypto.randomUUID();
            localStorage.setItem("ziege_device_id", deviceId);
        }
        return deviceId;
    }

}

async function createRoom(client, otherUserId){
    const room = await client.createRoom({
        /*name: "ZiegeZiege" + otherUserId,*/
        initial_state: [{
            type: ZIEGE_MARKER_STATE_EVENT_TYPE,
            visibility: Visibility.Private,
            state_key: "",
            //is_direct: true,
            content: {
                is_ziege: true,
            }
        },
            {
                type: "m.room.encryption",
                state_key: "",
                content: {
                    algorithm: MEGOLM_ENCRYPTION_ALGORITHM
                }
            }
        ]
    })


    //await client.sendStateEvent(room.room_id, "m.room.encryption", {
    //    algorithm: MEGOLM_ENCRYPTION_ALGORITHM, // Encryption algorithm
    //});


    await client.setRoomTag(room.room_id, ZIEGE_ROOM_TAG)
    await client.invite(room.room_id, otherUserId, "Ziege benutzen")
    return room;
}


// check the rooms timeline for a ziege event, return the latest ziege event found or null if none



async function enterTheMatrix(userId, deviceId, accessToken) {
    let checkedRooms = {} // rooms that we have seen a ziege event for or that we have search the timeline for ziege event of
    let client = null;

    let secretStorageKeyCache = {};

    const CHECKEDROOMS_TTL = 30000;

    function store_checkedroom(roomId, e, is_ziege=false) {
        const now = Date.now();
        checkedRooms[roomId] = {"expires": now + CHECKEDROOMS_TTL, "event": e, "is_ziege": is_ziege}
    }


    // opts is {loginToken, userId, deviceId, accessToken}
    let clientOpts = {
        baseUrl: ZIEGE_BASE_URL,
        cryptoCallbacks: {
            cacheSecretStorageKey: async (keyId, keyInfo, key) => {
                console.log("caching secret storage key: ", keyId)
                secretStorageKeyCache[keyId] = key;
            },

            getSecretStorageKey: async (keys) => {
                // This function should prompt the user to enter their secret storage key.
                console.log("Getting secret storage key:")
                console.log(keys)
                console.log(Object.keys(keys.keys))
                // let keyId = await cli.secretStorage.getDefaultKeyId();
                let keyId = Object.keys(keys.keys)[0]
                if (secretStorageKeyCache.hasOwnProperty(keyId)) {
                    return [keyId, secretStorageKeyCache[keyId]];
                }

                let key = prompt("Secret Key hmmm?")
                let decodedKey = decodeRecoveryKey(key)
                secretStorageKeyCache[keyId] = decodedKey;
                return [keyId, decodedKey]
            },
        },
        deviceId,
        accessToken,
        userId,
    }
    try {
        client = sdk.createClient(clientOpts);

        window.matrixClient = client; // FIXME: TEMP TEMP

        await client.initRustCrypto();


    } catch(e) {
        console.error("Crypto is bonk: ", e);
        console.warn("Let's go, no Cryp-to!")
        //console.error("bailing... no ziege for you")
        //return;
    }
    console.log("crypto is (maybe) go")

    async function handleEvent(event, roomId/*, toStartOfTimeline*/) {

        console.debug("room event: ", event);

        if (!await isZiegeRoom(client, roomId)) {
            console.debug("not a ziege room. ignoring event.")
            return false;
        }

        await client.decryptEventIfNeeded(event)

        let eventtype = event.getType()
        console.debug("room event type: ", eventtype);

        if (eventtype === ZIEGE_STATUS_UPDATE_MESSAGE_TYPE) {
            store_checkedroom(roomId,event,true);

            console.log("Shit it going down!")
            let content = event.getContent()
            emitStatusUpdate(roomId, content)
            return true
        }
        return false
    }



    async function checkRoom(roomId, room=null) {
        const now = Date.now();
        if (roomId in checkedRooms) {
            if (checkedRooms[roomId].expires > now) {
                console.log("checkedroom is still valid. returning.", roomId, checkedRooms[roomId]);
                return checkedRooms[roomId].event;
            }
        }

        if (!room) {
            room = client.getRoom(roomId);
        }

        if(!room) {
            console.error(`Room ${roomId || room} does not exist`);
            store_checkedroom(roomId,null);
            return null;
        }

        let timelineWindow = new sdk.TimelineWindow(client, room.getUnfilteredTimelineSet());
        let eventId = null; // we can fetch events around a specified event or set to null to go from end of timeline
        let initialWindowSize = 20; // number of events to grab for initial load
        await timelineWindow.load(eventId, initialWindowSize); // load the initial events (required step)
        let moreMessages = false
        do {

            // now we can grab the events
            let events = timelineWindow.getEvents();
            console.log("A batch of events: ", events)

            for (const e of [...events].reverse()) {
                if (e.getType() === ZIEGE_STATUS_UPDATE_MESSAGE_TYPE) {
                    console.log(`checkRoom found ziege event for ${roomId} (${e.getTs()})`)
                    store_checkedroom(roomId,e);
                    return e;
                }
            }

            // now lets move the window backwards
            // moreMessages will be false if there are no more events in this direction
            let backwards = true;
            moreMessages = await timelineWindow.paginate(backwards ? 'b' : 'f', 8);

            if (moreMessages) {
                // there are more messages, lets remove the previous page's events
                await timelineWindow.unpaginate(8, !backwards);

            }
        } while (moreMessages);

        store_checkedroom(roomId,null);
        return null;
    }

    /* -> {roomId -> {userId, roomId, displayName}}*/
    async function checkRooms() {
        console.debug("checking rooms...")
        const rooms = await client.getJoinedRooms()
        const whoami = client.getUserId()
        let result = {}
        if (!whoami) {
            console.debug("existential crisis.")
            return {}
        }

        for (const roomId of rooms.joined_rooms) {
            if (!await isZiegeRoom(client, roomId)) {
                console.debug("not a ziege room. ignoring.")
                continue;
            }

            /*const members  = await client.getJoinedRoomMembers(roomId)
            if (!members) {
                console.debug("no members. ignoring.")
                continue;
            }*/ // maybe include members in the future?
            let event = await checkRoom(roomId)
            store_checkedroom(roomId,event);
            if (event) {
                await handleEvent(event, roomId)
            }

        }
        return result;
    }

    const elmE = document.getElementById('elm');


    const emptyState =  { "session": null, "clients": [] }
    var data = { "state":emptyState, "userId": client.getUserId()  };

    try {
        data["state"] = JSON.parse(localStorage.getItem('ziege')) || emptyState
    } catch (e) {
        console.error("could not load ziege data: ", e)
    }




    const oidtoken = await client.getOpenIdToken();


    data["patternclientconfig"] =
        {
            "secret": "ishieng9iashue7usoimo8Su7phoogoh"
            ,
            "url": "https://admin.ziege.social/api/1/texelclient/",
            "clientname": "Texelclient",
            "ingesturl": "https://admin.ziege.social/api/1/ingest/",
            "favoriteurl":"https://admin.ziege.social/api/1/berater/favorites/",
            "researchurl": "https://admin.ziege.social/api/1/forschung/"
        }
    data["access_token"] =  oidtoken
    data["notification_permission"] = "unsupported"
    if (window.Notification) {
        data["notification_permission"] = Notification.permission
    }


    customElements.define("ziege-progress", ZiegeProgressElement);
    customElements.define("date-progress", DateProgressElement);
    console.log("Custom element ziege-progress is defined")

    var app = Elm.Main.init({
        node: elmE,
        flags: data,
    });

    console.log("elm is go")


    app.ports.saveData.subscribe(function (data) {
        console.log("saving ", data)
        localStorage.setItem('ziege', JSON.stringify(data));
    });

    app.ports.performCryptoInit.subscribe(async () => {
        console.info("elm request crypto init.... equal goes it loose")
        await initCrypto(client);
    })

    app.ports.performLogout.subscribe(async () => {
        console.log("logging out...")
        await client.logout(true)

        await client.clearStores()

        console.log("done. removing locally stored stuff.")
        localStorage.removeItem("ziege_access_token");
        localStorage.removeItem("ziege_user_id");
        localStorage.removeItem("ziege");

        // remove everything
        localStorage.clear()
        sessionStorage.clear()

        // FIXME: if crypto, then delete more stuff.

        console.log("reloading in 3s")
        window.setTimeout(() => window.location.reload(), 3000)
    })

    app.ports.requestNotificationPermission.subscribe(async () => {
        if (window.Notification) {
            let result = await Notification.requestPermission();
            console.log("Notification permission result: ", result);
            app.ports.notificationPermissionChanged.send(result);
        } else {
            app.ports.notificationPermissionChanged.send("unsupported");
        }
    });

    navigator.permissions
        .query({ name: "notifications" })
        .then((permissionStatus) => {
            console.debug(`notifications permission status is ${permissionStatus.state}`);
            permissionStatus.onchange = () => {
                console.debug(
                    `notifications permission status has changed to ${permissionStatus.state}`,
                );
                app.ports.notificationPermissionChanged.send(permissionStatus.state);
            };
        });


    // noinspection JSUnusedLocalSymbols
    async function emitError(message, canContinue) {
        console.log("emitError:", message, canContinue);
        app.ports.receiveMatrixError.send({message, canContinue});
    }


    app.ports.inviteToRoom.subscribe(async function (message) {
        console.log(`initing ${message.userid} to existing room ${message.roomid}`)
        await client.invite(message.roomid, message.userid, "Ziege benutzen")
    })

    app.ports.leaveRoom.subscribe(async function ({roomid}) {
        console.log(`leaving ${roomid}`)
        await client.leave(roomid)
    })


    app.ports.sendMessage.subscribe(async function (message) {
        console.log("sending message: ", message);
        let roomId = message.roomid
        if (!roomId) {
            console.log("Creating room for: ", message.userid)

            let newRoom = await createRoom(client,  message.userid)
            console.log("newROom is ", newRoom)
            roomId = newRoom.room_id
        }
        console.log(`sending status into ${roomId}: `, message);
        await client.sendEvent(roomId, ZIEGE_STATUS_UPDATE_MESSAGE_TYPE, message.payload, "")

    })

    function emitStatusUpdate(roomId, status) {
        console.log("Matrix -> Ziege.elm: Status Update")
        app.ports.receiveStatusUpdate.send({ "roomid": roomId, "userid": "", "payload": status })
        playPling();
    }

    function emitLeaveRoom(roomId) {
        console.log(`Matrix -> Ziege.elm: Left the room ${roomId}`)
        app.ports.receiveRoomSeverance.send({ "roomid": roomId})
    }

    async function initCrypto(client) {

        console.log("Bootstraping the signing of crosses without upload thingy....")
        // what about the upload
        await client.getCrypto().bootstrapCrossSigning({})

        await client.getCrypto().bootstrapSecretStorage({
            // This function will be called if a new secret storage key (aka recovery key) is needed.
            // You should prompt the user to save the key somewhere, because they will need it to unlock secret storage in future.
            createSecretStorageKey: async () => {
                let newKey = new Uint8Array(32)
                newKey = crypto.getRandomValues(newKey)
                let encodedKey = encodeRecoveryKey(newKey);
                do {
                    alert("Dies ist der Key. Bitte unbedingt merken: " + encodedKey)
                } while (!confirm("Wurde der recovery key gut weggelegt? Wo ihn niemand findet? Ausser wenn er gebraucht wird? Das ist echt wichtig."))
                console.log("returning the new key from createSecretStorageKey:")
                return {privateKey: newKey,
                    encodedPrivateKey: encodedKey};
            },
        });




        //client.getCrypto().store.deleteAllData()


        // Check if we have a key backup.
        // If checkKeyBackupAndEnable returns null, there is no key backup.
        if ((await client.getCrypto().checkKeyBackupAndEnable()) === null) {
            console.log("Resetting the key backup...")
            await client.getCrypto().resetKeyBackup()
        }
    }

    async function updateCryptoStatus() {
        let bi = await window.matrixClient.getCrypto().getKeyBackupInfo()

        let status = {
            secretStorageReady: await client.getCrypto().isSecretStorageReady(),
            isBackupTrusted:  bi && (await client.getCrypto().isKeyBackupTrusted(bi)),
            isCrossSigningReady: await  window.matrixClient.getCrypto().isCrossSigningReady()
        }
        console.debug("Sending crypto status to elm: ", status)
        app.ports.receiveCryptoStatus.send(status)
    }

    function initEventHandlers(client) {

        // AI code below.
        client.on("event.decryption_failed", async (event) => {
            console.error("Decryption failed for event:", event);

            if (event.getContent().msgtype === "m.bad.encrypted") {
                console.log("bad bad crypto")

                //console.log("Requesting keys from other devices...");
                //await client.getCrypto().requestRoomKey(event);
            }
        });


        client.on(RoomMemberEvent.Membership, async (event/*, member, oldMembership*/) => {
            console.log("membership event out: ", event, event.getRoomId());
            const roomId = event.getRoomId();
            window.setTimeout(async () => {
                console.log("membership event: ", event, roomId);

                let anotherEvent = await checkRoom(roomId)
                if (anotherEvent) {
                    await handleEvent(anotherEvent, roomId)
                }
            })
        })

        client.on("Room.timeline", (rawEvent, room) => handleEvent(rawEvent, room.roomId))
        client.on(RoomEvent.MyMembership, async function (room, membership/*, prevMembership*/) {
            //if (!await isZiegeRoom(client, room.roomId, room)) {
            //    console.log("invite? not a ziege room. ignoring event.")
            //    return;
            //} // FIXME FIXME FIXME only join ziege rooms

            if (membership === KnownMembership.Invite) {
                await client.joinRoom(room.roomId)
                console.log("Auto-joined Ziege-Room %s", room.roomId);
            } else if (membership === KnownMembership.Leave) {
                await emitLeaveRoom(room.roomId);
                return;
            }
            let event = await checkRoom(null, room);
            store_checkedroom(room.roomId, event);
            if (event) {
                await handleEvent(event, room.roomId)
            }
        });

        client.on("crypto.devicesUpdated", (users) => {
            console.log("Devices updated for users:", users);

            users.forEach((userId) => {
                const devices = client.getCrypto().getUserDeviceInfo(userId);
                for (const [deviceId, device] of Object.entries(devices)) {
                    if (!device.isVerified()) {
                        console.warn(`Device ${deviceId} for ${userId} is unverified.`);
                        // Consider verifying it manually here if you trust the device
                    }
                }
            });
        });

        client.getCrypto()?.on(CryptoEvent.UserTrustStatusChanged, (/*userId, userTrustLevel*/) => { updateCryptoStatus(); })
        client.getCrypto()?.on(CryptoEvent.KeyBackupStatus, (/*backupEnabled*/) => { updateCryptoStatus(); })
        client.getCrypto()?.on(CryptoEvent.KeyBackupFailed, (/*err*/) => { updateCryptoStatus(); })
        client.getCrypto()?.on(CryptoEvent.KeysChanged, (/*err*/) => { updateCryptoStatus(); })
    }


    client.once(ClientEvent.Sync, async (/*state, prevState, res */) => {
        //await initCrypto(client) // we do not simply init crypto. Let's see what breaks...
        await initEventHandlers(client)
    });

    client.on(ClientEvent.Sync, async (state /*, prevState, res*/) => {
        console.log("on the syncing...")
        console.log("state is ",state)
        switch (state) {
            case "PREPARED":
                // recheck all rooms.
                console.log("rechecking all the rooms.");
                checkedRooms = {}
                await checkRooms()

                break
        }

    });

    async function updateAccessToken(initialtoken) {
        console.debug("oidtoken getting")


        const oidtoken = initialtoken || await client.getOpenIdToken();

        console.debug("oidtoken: ", oidtoken)

        app.ports.receiveAccessToken.send(oidtoken)

        // => { access_token, token_type, matrix_server_name, expires_in }
        window.setTimeout(updateAccessToken, Math.max(120 * 1000.0, (oidtoken.expires_in-15) * 1000.0))
    }



    updateAccessToken(oidtoken); // to star the timeout thing.
    updateCryptoStatus()


    console.log("starting the matrix client")
    await client.startClient({initialSyncLimit: 20});
    console.log("done starting the matrix client")







    //console.log("Cross-signing keys:", client.getStoredCrossSigningForUser());
    console.log("Own verified devices:", client.getAccountData("m.device_list"));




    window.requestOwnVerification = async function() {

        console.log("Requesting own verification...")

        const verifier = await client.getCrypto().requestOwnUserVerification()

        // Listen for verification events and user interaction
        verifier.on("show_sas", (event) => {
            const { sas } = event; // SAS = Short Authentication String

            console.log("SAS Received! Show this to the user:", sas);

            // Display the SAS to the user for verification, e.g., numbers or emojis.
            prompt(`Confirm the following SAS string on both devices: ${sas[0]} ${sas[1]} ${sas[2]}`);

            // Simulate user approval (must be an actual user interaction in production)
            verifier.confirm(); // Signals the user has verified the SAS
        });

        verifier.on("done", () => {
            console.log("Verification completed successfully!");
            alert("Device verification successful!");
        });

        verifier.on("cancel", (err) => {
            console.error("Verification canceled or failed:", err);
            alert("Verification failed or canceled.");
        });

        verifier.on("error", (err) => {
            console.error("Verification error occurred:", err);
        });


        return verifier;
    }

    window.verifyDevice = async function (userId, deviceId) {
        try {
            // Start the verification request
            console.log(`Starting verification with ${userId}'s device ${deviceId}`);

            const verifier = await client.getCrypto().requestDeviceVerification(userId, deviceId);

            // Listen for verification events and user interaction
            verifier.on("show_sas", (event) => {
                const { sas } = event; // SAS = Short Authentication String

                console.log("SAS Received! Show this to the user:", sas);

                // Display the SAS to the user for verification, e.g., numbers or emojis.
                prompt(`Confirm the following SAS string on both devices: ${sas[0]} ${sas[1]} ${sas[2]}`);

                // Simulate user approval (must be an actual user interaction in production)
                verifier.confirm(); // Signals the user has verified the SAS
            });

            verifier.on("done", () => {
                console.log("Verification completed successfully!");
                alert("Device verification successful!");
            });

            verifier.on("cancel", (err) => {
                console.error("Verification canceled or failed:", err);
                alert("Verification failed or canceled.");
            });
        } catch (err) {
            console.error("Error during verification:", err);
        }
    }


    console.log("Call window.verifyDevice('@user:example.com', 'DEVICE_ID'); to verify");

    async function nosy(msg){
        if (!msg) {
            console.log("roomlist");
            return;
        }
        if (msg === "roomlist") {
            for (const roomId in isziege_cache) {
                if (isziege_cache[roomId].is_ziege) {
                    console.log(roomId, isziege_cache[roomId]);
                    console.log("ZIEGE", await client.getRoom(roomId));
                }
            }
            for (const roomId in isziege_cache) {
                if (!isziege_cache[roomId].is_ziege) {
                    console.log(roomId, isziege_cache[roomId]);
                    console.log("NON-ZIEGE", await client.getRoom(roomId));
                }
            }
        }
    }
    window.ziege_maul = nosy;

}

let ISZIEGE_TTL = 30000;
let isziege_cache = {}

async function isZiegeRoom(client, roomId, room=null) {
    //let summary = await client.getRoomSummary(roomId)
    // if (summary && summary.name && summary.name.toLowerCase().includes("ziege")) {
    //     return true;
    // }
    console.log("isZiegeRoom: ", roomId, room);

    const now = Date.now()
    if (roomId in isziege_cache) {
        if (isziege_cache[roomId].expires > now) {
            console.log("isZiegeRoom: cache is still valid. returning.", roomId, isziege_cache[roomId]);
            return isziege_cache[roomId].is_ziege;
        }
    }



    if (!room) {
        room = await client.getRoom(roomId);
    }

    if (!room) {
        console.debug("no room?", roomId);
        // isziege_cache[roomId] = {"expires":now+ISZIEGE_TTL, "is_ziege": false}
        return false;
    }
    console.debug("checking room for ziegeness:", room.normalizedName, roomId)
    //if (room && room.name && room.name.toLowerCase().includes("ziege")) {
    //    return true;
    //}
    try {
        //let is_ziege = await client.getStateEvent(roomId, ZIEGE_MARKER_STATE_EVENT_TYPE, "")
        //FIXME: better is_ziege erkennung
        console.log("Room is baeh! Hurra!")
        isziege_cache[roomId] = {"expires":now+ISZIEGE_TTL, "is_ziege": true}
        return true;

    } catch (error) {
        console.log(`Room ${roomId} is not baeh.`, error)
    }
    isziege_cache[roomId] = {"expires":now+ISZIEGE_TTL, "is_ziege": false}
    return false;
}

async function logintokenReceived(loginToken, initialDeviceId) {
    console.log("loginToken received. continue sso login...")
    const client = sdk.createClient({baseUrl: ZIEGE_BASE_URL, deviceId: initialDeviceId});

    let loginResponse = await client.loginRequest({
        device_id: initialDeviceId,
        type: "m.login.token",
        token: loginToken
    })


    let accessToken = loginResponse.access_token
    let userId = loginResponse.user_id
    let deviceId = loginResponse.device_id
    localStorage.setItem("ziege_access_token", accessToken);
    localStorage.setItem("ziege_user_id", userId);
    localStorage.setItem("ziege_device_id", deviceId)

    window.history.replaceState(null, '', window.location.pathname) // remove login token...

    await enterTheMatrix(userId, deviceId, accessToken);
}







export default async function buildZiegeApp(actualUri = null) {
    const deviceId = getDeviceId();
    console.log("building ziege app with uri: ", actualUri);
    let searchPart = window.location.search

    if (actualUri) {
        const u = new URL(actualUri);
        searchPart = u.search;

    }

    const urlParams = new URLSearchParams(searchPart);
    const loginToken = urlParams.get('loginToken');
    if (loginToken) {
        document.body.innerHTML = `<h1>Danke! Sie sind angemeldet. Ziege wird gestartet.</h1>`
        // FIXME: if already logged in, clean the shit?
        logintokenReceived(loginToken, deviceId)
        return;
    }


    const elmE = document.getElementById('elm');

    const accessToken = localStorage.getItem("ziege_access_token");
    const userId = localStorage.getItem("ziege_user_id");

    if (accessToken && userId) {
        console.log(`Vermutlich angemeldet als ${userId}...`);

        try {
            enterTheMatrix(userId, deviceId, accessToken);
        } catch (e) {
            elmE.appendChild(document.createTextNode(e.message));
        }

        /*let logoutButtonE = document.createElement("button")
        logoutButtonE.innerText = "Abmelden und alles vergessen"

        logoutButtonE.addEventListener("click", async () => {
            localStorage.removeItem("ziege_access_token");
            localStorage.removeItem("ziege_user_id");
            localStorage.removeItem("ziege");

            let client = sdk.createClient({baseUrl: "https://matrix.ziege.social", accessToken, userId, deviceId});
            try {
                await client.initRustCrypto();



            } catch(e) {
                console.error("Crypto is bonk: ", e);
            }

            console.log("logging out")
            await client.logout(true)
            setTimeout(() => {location.reload();}, 10)
        })

        elmE.appendChild(buttonE)
        elmE.appendChild(logoutButtonE)*/
    } else {
        console.log("Go SSO!")
        try {

            let client = sdk.createClient({baseUrl: ZIEGE_BASE_URL, deviceId});

            let ssoUri = await client.getSsoLoginUrl(calculate_sso_redirect_uri())
            console.log(ssoUri)


            document.body.innerHTML = `
            <h1>Die Anmeldung bei Ziege erfolgt über den Browser beim Ziege-Anmelde-Server.</h1>
            <p></p><a href="${ssoUri}">Zur Anmeldung</a></p>
            <div></div>
           `
            // ins letzte Diff könnte noch nen Bild. Und insgesamt hübscher.
            window.location.href = ssoUri;

            // gone to OIDC...


            //const response = await client.login("m.login.password", {user, password})
            //localStorage.setItem("ziege_access_token", response.access_token);
            //localStorage.setItem("ziege_user_id", client.getUserId());

        } catch (e) {
            elmE.appendChild(document.createTextNode(e.message));
        }

    }

}

